import styles from './article-more-menu.module.scss';
import { TArticle, TUser } from '../../../models/common';
import { WDivider, WListItemIcon, WMenu, WMenuItem } from '../../wrappers/wrapper';
import Share from '@mui/icons-material/Share';
import Delete from '@mui/icons-material/Delete';
import { UserContext } from 'contexts/userContext';
import { useContext } from 'react';
import helperService from 'services/helper.service';

interface ArticleListItemProps {
  article: TArticle;
  open: boolean;
  anchorEl: HTMLElement | null;
  deleteArticle: (article_id: string) => any;
  handleClose: () => void;
}

const ArticleMoreMenu: React.FC<ArticleListItemProps> = ({
  article,
  open,
  anchorEl,
  deleteArticle,
  handleClose,
}) => {
  const { user } = useContext(UserContext);
  const isOwner = user?._id === (article.publisher as TUser)._id;

  const handleClickShare = () => {
    const liknk = `${window.location.href}/${article._id}`;

    navigator.clipboard.writeText(liknk).then(() => {
      helperService.showToast('info', 'Link copied to clipboard!');
      handleClose();
    });
  };

  const handleClickDelete = () => {
    handleClose();
    deleteArticle(article._id!);
  };

  return (
    <WMenu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            border: 'var(--border-light)',
            padding: '0.5rem',
            width: '10rem',
            borderRadius: 'var(--border-radius)',
            backgroundColor: 'var(--color-content-background)',
            color:"white"
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className={styles.menu}
    >
      <WMenuItem onClick={handleClickShare}>
        <WListItemIcon style={{ color: 'var(--color-white)' }}>
          <Share />
        </WListItemIcon>
        Share
      </WMenuItem>
      {isOwner && (
        <div className={styles.bottom}>
          <WDivider className={styles.divider} />
          <WMenuItem onClick={handleClickDelete} className={styles.delete}>
            <WListItemIcon>
              <Delete />
            </WListItemIcon>
            <span>Delete</span>
          </WMenuItem>
        </div>
      )}
    </WMenu>
  );
};

export default ArticleMoreMenu;
